/* gs-strive-pdp-detail — hero carousel + quantity + selling-plan select
   sync. No deps. Idempotent (safe to load twice). */
(function () {
  'use strict';

  function initHero(root) {
    var hero = root.querySelector('[data-hero-target]');
    var track = hero ? hero.querySelector('[data-hero-track]') : null;
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hero-slide]'));
    var looped = slides.length > 1;
    var realCount = looped ? slides.length - 2 : slides.length;
    if (realCount < 2) return;

    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-index]'));

    var trackIndex = looped ? 1 : 0;
    var settleTimer = null;

    function jump(index) {
      track.classList.add('gs-strive-pdp-detail__hero-track--no-smooth');
      void track.offsetHeight;
      track.scrollLeft = track.clientWidth * index;
      requestAnimationFrame(function () {
        track.classList.remove('gs-strive-pdp-detail__hero-track--no-smooth');
      });
      trackIndex = index;
    }

    function scrollToIndex(index) {
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    }

    function realIndexFromTrack(index) {
      if (!looped) return index;
      if (index <= 0) return realCount - 1;
      if (index >= realCount + 1) return 0;
      return index - 1;
    }

    function updateUI(index) {
      var realIndex = realIndexFromTrack(index);
      thumbs.forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-thumb-index'), 10);
        btn.classList.toggle('is-active', i === realIndex);
      });
    }

    function settle() {
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);

      if (looped && index <= 0) {
        jump(realCount);
        updateUI(realCount);
        return;
      }

      if (looped && index >= realCount + 1) {
        jump(1);
        updateUI(1);
        return;
      }

      trackIndex = index;
      updateUI(index);
    }

    function onScroll() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 120);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(trackIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(trackIndex + 1);
      });
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-thumb-index'), 10);
        scrollToIndex(looped ? i + 1 : i);
      });
    });

    track.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', function () {
      jump(trackIndex);
    });

    function positionInitial() {
      if (track.clientWidth === 0) return false;
      jump(trackIndex);
      updateUI(trackIndex);
      track.classList.add('gs-strive-pdp-detail__hero-track--ready');
      return true;
    }

    if (!positionInitial()) {
      window.addEventListener('load', positionInitial);
    }
  }

  function init(root) {
    if (!root || root.dataset.gsPdpInit === '1') return;
    root.dataset.gsPdpInit = '1';

    initHero(root);

    /* Frequency select mirrors the chosen selling plan into the
       subscription radio's value — the radio (not the select) is the
       form-associated selling_plan input, so only one input carries
       the name. */
    var subRadio = root.querySelector('[data-sub-radio]');
    var planSelect = root.querySelector('[data-plan-select]');
    var subPrice = root.querySelector('[data-sub-price]');
    if (subRadio && planSelect) {
      planSelect.addEventListener('change', function () {
        var opt = planSelect.options[planSelect.selectedIndex];
        subRadio.value = planSelect.value;
        subRadio.checked = true;
        var price = opt ? opt.getAttribute('data-price') : null;
        if (subPrice && price) subPrice.textContent = price;
      });
    }

    var qtyInput = root.querySelector('.gs-strive-pdp-detail__qty-input');
    var dec = root.querySelector('[data-qty-decrease]');
    var inc = root.querySelector('[data-qty-increase]');
    if (qtyInput) {
      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }
  }

  function boot() {
    document.querySelectorAll('.gs-strive-pdp-detail').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('.gs-strive-pdp-detail')
      : null;
    if (root) init(root);
  });
})();